import React, { createContext, useContext, useState, useEffect } from 'react';

const PageContext = createContext();

export const usePage = () => {
  const context = useContext(PageContext);
  if (!context) {
    throw new Error('usePage must be used within a PageProvider');
  }
  return context;
};

export const PageProvider = ({ children }) => {
  const [currentPage, setCurrentPage] = useState('home');

  // Detect current page from URL
  useEffect(() => {
    const handleRouteChange = () => {
      const path = window.location.pathname;
      const pageName = path === '/' ? 'home' : path.replace('/', '').split('/')[0];
      setCurrentPage(pageName);
    };

    handleRouteChange();
    window.addEventListener('popstate', handleRouteChange);

    // Also listen for pushState and replaceState
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    history.pushState = function(...args) {
      originalPushState.apply(this, args);
      handleRouteChange();
    };

    history.replaceState = function(...args) {
      originalReplaceState.apply(this, args);
      handleRouteChange();
    };

    return () => {
      window.removeEventListener('popstate', handleRouteChange);
      history.pushState = originalPushState;
      history.replaceState = originalReplaceState;
    };
  }, []);

  const value = {
    currentPage,
    setCurrentPage,
  };

  return (
    <PageContext.Provider value={value}>
      {children}
    </PageContext.Provider>
  );
};